import styled, { StyledProps } from 'styled-components/macro';

export type CellEditStylesProps = StyledProps<{
}>;

export const CellEdit = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
`;